<template>
  <div class="vqb-children">
    <component
      v-for="(child, index) in query.children"
      :key="index"
      :is="getComponent(child.type)"
      :depth="depth + 1"
      :query="child.query"
      :index="index"
      class="my-2"
      :vars="vars"
      :members="members"
    />
  </div>
</template>

<script>

import ExpressionGroup from '@/components/notifications/settings/ExpressionGroup';
import ExpressionRule from '@/components/notifications/settings/ExpressionRule';

export default {
  name: 'ExpressionChildren',
  props: ['query', 'depth', 'vars', 'members'],
  methods: {
    getComponent(type) {
      return type === 'query-builder-group'
        ? ExpressionGroup
        : ExpressionRule;
    },
  },
};
</script>

<style scoped>

</style>
